import styled from 'styled-components';
import { corBorda, corErro, corFundo, corPrimaria, corTextoSuave, fonte, tamanhoBase } from './estilos/tokens';

export const TAMANHO_DO_BOTAO = 56;
export const ESPACO_ENTRE_BOTAO_E_JANELA = 12;
const MARGEM_LATERAL = 16;

export const Botao = styled.button`
    position: fixed;
    right: ${MARGEM_LATERAL}px;
    bottom: ${({ $margemInferior }) => $margemInferior}px;
    z-index: 1040;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${TAMANHO_DO_BOTAO}px;
    height: ${TAMANHO_DO_BOTAO}px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: ${corPrimaria};
    color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    cursor: pointer;

    &:hover {
        filter: brightness(1.15);
    }

    &:focus-visible {
        outline: 3px solid ${corBorda};
        outline-offset: 2px;
    }
`;

export const Painel = styled.div`
    position: fixed;
    right: ${MARGEM_LATERAL}px;
    bottom: ${({ $margemInferior }) => $margemInferior + TAMANHO_DO_BOTAO + ESPACO_ENTRE_BOTAO_E_JANELA}px;
    z-index: 1045;
    /* Tamanho escolhido pelo usuário (variáveis no style, para o arraste não gerar uma classe por pixel). */
    width: var(--chat-ia-largura, 400px);
    height: var(--chat-ia-altura, 600px);
    max-width: calc(100vw - ${MARGEM_LATERAL * 2}px);
    max-height: calc(100vh - ${({ $margemInferior }) => $margemInferior + 80}px);
    overflow: hidden;
    border-radius: 12px;
    background: ${corFundo};
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.28);
    font-family: ${fonte};
    font-size: ${tamanhoBase};

    &[hidden] {
        display: none;
    }

    &:focus {
        outline: none;
    }

    /* Expandida: ocupa quase toda a altura disponível e até 1100px de largura. */
    &[data-expandida='true'] {
        width: 1100px;
        height: 100vh;
    }

    /* Telas pequenas: a janela ocupa a viewport inteira; o "Fechar" da própria janela a esconde. */
    @media (max-width: 575.98px) {
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: auto;
        height: auto;
        padding-bottom: env(safe-area-inset-bottom);
        box-sizing: border-box;
        max-width: none;
        max-height: none;
        border-radius: 0;

        &[data-expandida='true'] {
            width: auto;
            height: auto;
        }
    }
`;

// Alças de redimensionar: a janela fica presa embaixo à direita, então o canto e as bordas de cima/esquerda.
const Alca = styled.div`
    position: absolute;
    z-index: 2;

    @media (max-width: 575.98px) {
        display: none;
    }
`;

export const AlcaEsquerda = styled(Alca)`
    top: 12px;
    bottom: 0;
    left: 0;
    width: 6px;
    cursor: ew-resize;
`;

export const AlcaDeCima = styled(Alca)`
    top: 0;
    right: 0;
    left: 12px;
    height: 5px;
    cursor: ns-resize;
`;

export const AlcaDoCanto = styled(Alca).attrs({ as: 'button', type: 'button' })`
    top: 0;
    left: 0;
    width: 14px;
    height: 14px;
    padding: 0;
    border: 0;
    border-top-left-radius: 12px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.55) 0 30%, transparent 30%);
    cursor: nwse-resize;

    &:focus-visible {
        outline: 2px solid white;
        outline-offset: -2px;
    }
`;

export const Carregando = styled.p`
    margin: 0;
    padding: 24px 12px;
    color: ${corTextoSuave};
    text-align: center;
`;

export const Falha = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 24px 12px;
    color: ${corErro};
    text-align: center;

    p {
        margin: 0;
    }
`;

export const BotaoTentar = styled.button`
    padding: 6px 14px;
    border: 1px solid ${corPrimaria};
    border-radius: 6px;
    background: white;
    color: ${corPrimaria};
    font: inherit;
    cursor: pointer;
`;
